<template>
  <div class="box-drift">
    <h5>Se están cargando datos. Por favor, espere</h5>
    <h5 v-if="this.stepString!=''">({{this.stepString}})</h5>
    <div class="box-bob">
      <div class="box-pitch">
        <div class="left-sail"></div>
        <div class="right-sail"></div>
        <div class="hull"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    stepString: {
      type: String,
      default: ''
    },
  }
}
</script>
<style scoped>
body {
  background: #004283;
}
.box-drift {
  position: absolute;
  width: 100px;
  height: 60%;
  left: 0%;
  animation: doDrift 16s infinite;
}
.box-bob {
  position: absolute;
  top: 50%;
  width: 100px;
  background: none;
  animation: doBob 2s infinite;
}
.box-pitch {
  height: 100px;
  animation: doPitch 1s infinite;
}
.left-sail {
  background: #3e6287;
  position: absolute;
  top: 20%;
  left: 5%;
  width: 40%;
  height: 40%;
  -webkit-clip-path: polygon(100% 0, 0% 100%, 100% 100%);
  clip-path: polygon(100% 0, 0% 100%, 100% 100%);
}
.right-sail {
  background: #3e6287;
  position: absolute;
  top: 5%;
  left: 50%;
  width: 45%;
  height: 55%;
  -webkit-clip-path: polygon(0 0, 0% 100%, 100% 100%);
  clip-path: polygon(0 0, 0% 100%, 100% 100%);
}
.hull {
  background: #3e6287;
  position: absolute;
  top: 65%;
  left: 10%;
  width: 80%;
  height: 25%;
  -webkit-clip-path: polygon(0 0, 100% 0, 79% 100%, 18% 100%);
  clip-path: polygon(0 0, 100% 0, 79% 100%, 18% 100%);
}
@keyframes doBob {
  0% {
    top: 55%;
  }
  50% {
    top: 47%;
  }
  100% {
    top: 55%;
  }
}
@keyframes doDrift {
  0% {
    left: 0%;
  }
  10% {
    left: 10%;
  }
  20% {
    left: 20%;
  }
  50% {
    left: 50%;
  }
  50% {
    left: 50%;
  }
  80% {
    left: 80%;
  }
  100% {
    left: 90%;
  }
}
@keyframes doPitch {
  0% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(-10deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/BoatSailing.vue